var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.786 82.1963C121.06 80.3812 119.622 78.9431 117.807 78.2171L67.2991 58.014C64.6461 56.9528 61.616 57.5748 59.5956 59.5952C57.5751 61.6157 56.9532 64.6458 58.0143 67.2988L78.2174 117.806C78.9434 119.621 80.3816 121.06 82.1966 121.786L132.704 141.989C135.357 143.05 138.387 142.428 140.408 140.407C142.428 138.387 143.05 135.357 141.989 132.704L121.786 82.1963ZM109.659 90.3449L90.3452 109.659L77.4681 77.4678L109.659 90.3449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.711 170.711C209.763 131.658 209.763 68.3418 170.711 29.2893C131.658 -9.76311 68.3418 -9.76311 29.2893 29.2893C-9.76311 68.3417 -9.76311 131.658 29.2893 170.711C68.3417 209.763 131.658 209.763 170.711 170.711ZM160.609 39.3909C194.083 72.8644 194.083 127.136 160.609 160.609C127.136 194.083 72.8643 194.083 39.3908 160.609C5.91734 127.136 5.91734 72.8643 39.3908 39.3908C72.8644 5.91734 127.136 5.91734 160.609 39.3909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripPlanner);
export default __webpack_public_path__ + "static/media/trip-planner.5e7d0b253573d44a75a82448ebd47986.svg";
export { ForwardRef as ReactComponent };